import { combineReducers } from 'redux';
import { config } from './config';
import { filter } from './filter';
import { documents } from './documents';
import { identities } from './identities';
import { bundles } from './bundles';
import { templates } from './templates';
import { user } from './user';

export default combineReducers({
  config,
  filter,
  documents,
  identities,
  bundles,
  templates,
  user
});
